
import { localizer } from "../../Translator"
export default class DateCustom {

  static MONTHS = () => {
    return [
      { number: 1, name: localizer.January },
      { number: 2, name: localizer.February },
      { number: 3, name: localizer.March },
      { number: 4, name: localizer.April },
      { number: 5, name: localizer.May },
      { number: 6, name: localizer.June },
      { number: 7, name: localizer.July },
      { number: 8, name: localizer.August },
      { number: 9, name: localizer.September },
      { number: 10, name: localizer.October },
      { number: 11, name: localizer.November },
      { number: 12, name: localizer.December }
    ]
  }

  static YEARS = () => {
    let currentYear = new Date().getFullYear()
    let years = []
    let startYear = 1980;
    while (startYear <= currentYear) {
      years.push((startYear++).toString())
    }
    return years
  }

  static formatDate = (stringDate) => {
    var date = new Date(stringDate)
    var cultureUsed = window.localStorage.getItem("culture")
    if (!cultureUsed) cultureUsed = 'en'
    return date.toLocaleString(cultureUsed)
  }
  
  static convertUTCToLocalTime = (dateString) => {
    let date = new Date(dateString);
    const milliseconds = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    );
    const localTime = new Date(milliseconds);
    var cultureUsed = window.localStorage.getItem("culture")
    if (!cultureUsed) cultureUsed = 'en'
    return localTime.toLocaleString(cultureUsed)
  }
  
  //return time with YYYY-MM-DDTHH:mm format
  static convertUTCToLocalTimeShort = (dateString) => {
    if (dateString === null || dateString === undefined) {
      const MONTHS = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      var date1 = new Date()
      dateString = date1.getUTCFullYear() +
        "-" + MONTHS[date1.getUTCMonth()] +
        "-" + date1.getUTCDate().toString().padStart(2, "0") +
        "T" + date1.getUTCHours().toString().padStart(2, "0") +
        ":" + date1.getUTCMinutes().toString().padStart(2, "0") +
        ":" + date1.getUTCSeconds().toString().padStart(2, "0")
    }
    
    let date = new Date(dateString);
    const milliseconds = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    );
    const localTime = new Date(milliseconds);
    var t = localTime.toLocaleTimeString();
    t = t.replace(/\u200E/g, '');
    t = t.replace(/^([^\d]*\d{1,2}:\d{1,2}):\d{1,2}([^\d]*)$/, '$1$2');
    var month = ("0" + (date.getMonth() + 1)).slice(-2)   // month with 2 digits
    var day = ("0" + date.getDate()).slice(-2)            // day with 2 digits
    t = t.padStart(5, '0');                               // hour 2 digits + ':' + ss
    
    var result = date.getFullYear() + '-' + month + '-' + day + 'T' + t;
    
    /* var result = month + '-' + day + '-' +  date.getFullYear()  +'T' + t;
    if (cultureUsed == 'es') {
      var cultureUsed = window.localStorage.getItem("culture")
      if (!cultureUsed) cultureUsed = 'en'
      result = day + '-' + month + '-' +  date.getFullYear()  +'T' + t;
    } */

    return result;
  }

  //return time with YYYY-MM-DD format
  static convertUTCToLocalShort = (dateString) => {
    if (dateString === null || dateString === undefined) {
      const MONTHS = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      var date1 = new Date()
      dateString = date1.getUTCFullYear() +
        "-" + MONTHS[date1.getUTCMonth()] +
        "-" + date1.getUTCDate().toString().padStart(2, "0") +
        "T" + date1.getUTCHours().toString().padStart(2, "0") +
        ":" + date1.getUTCMinutes().toString().padStart(2, "0") +
        ":" + date1.getUTCSeconds().toString().padStart(2, "0")
    }
    
    let date = new Date(dateString);
    
    var month = ("0" + (date.getMonth() + 1)).slice(-2)   // month with 2 digits
    var day = ("0" + date.getDate()).slice(-2)            // day with 2 digits
    
    var result = date.getFullYear() + '-' + month + '-' + day
    
    return result;
  }

  static equals = (stringDate1, stringDate2) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)

    return date1 === date2;
  }

  /**
   * Provides the date in UTC from a local time date.
   * @param {Date} date Local date to be converted.
   * @param {int} yearsToAdd Number of years to be added to the resulting date.
   */
  static convertToUtcDate(date, yearsToAdd) {
    var utcDate = (date.getUTCFullYear() + yearsToAdd) +
      "-" + (date.getUTCMonth() + 1).toString().padStart(2, "0") +
      "-" + date.getUTCDate().toString().padStart(2, "0") +
      "T" + date.getUTCHours().toString().padStart(2, "0") +
      ":" + date.getUTCMinutes().toString().padStart(2, "0") +
      ":" + date.getUTCSeconds().toString().padStart(2, "0")
    return utcDate
  }
  /**
   * Provides the date in UTC from a local time date.
   * @param {Date} date Local date to be converted.
   */
  static convertToUtcDateTime(date) {
    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    var dateTime
    if (date === null || date === undefined) {
      dateTime = new Date()
    } else {
      dateTime = new Date(date)
    }
     
    var utcDate = dateTime.getUTCFullYear() +
      "-" + months[dateTime.getUTCMonth()] +
      "-" + dateTime.getUTCDate().toString().padStart(2, "0") +
      "T" + dateTime.getUTCHours().toString().padStart(2, "0") +
      ":" + dateTime.getUTCMinutes().toString().padStart(2, "0") +
      ":" + dateTime.getUTCSeconds().toString().padStart(2, "0")
    
    return utcDate
  }

  static greaterThan = (stringDate1, stringDate2) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)

    return date1 > date2;
  }

  static lowerThan = (stringDate1, stringDate2) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)

    return date1 < date2;
  }

  static greaterEqualThan = (stringDate1, stringDate2) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)

    return date1 >= date2;
  }

  static lowerEqualThan = (stringDate1, stringDate2) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)

    return date1 <= date2;
  }

  static dateDiff = (stringDate1, stringDate2, format) => {
    var date1 = new Date(stringDate1)
    var date2 = new Date(stringDate2)
        
    const diffTimeMilliseconds = Math.abs(date2 - date1);

    var result = null
    switch (format.toUpperCase()) {
      case 'DAYS':
        result = Math.ceil(diffTimeMilliseconds / (1000 * 60 * 60 * 24))
        break;
      case 'HOURS':
        result = Math.ceil(diffTimeMilliseconds / (1000 * 60 * 60))
        break;
      case 'MINUTES':
        result = Math.ceil(diffTimeMilliseconds / (1000 * 60))
        break;
      case 'SECONDS':
        result = Math.ceil(diffTimeMilliseconds / (1000))
        break;
      default:
        break;
    }

    return result
  }

  /* format DD/MM/YYYY */
  static formatDateShort = (date) => {
    /*var d = new Date(date);
    var year = d.getFullYear();
    var month = ("0" + (d.getMonth() + 1)).slice(-2)   // month with 2 digits
    var day = ("0" + d.getDate()).slice(-2)
    return [day, month,year ].join('/');*/
    var d = new Date(date);
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "numeric"
    };
    var cultureUsed = window.localStorage.getItem("culture")
    if (!cultureUsed) cultureUsed = 'en'
    return d.toLocaleDateString(cultureUsed, options)
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/DateCustom.js